import AuthorsAutocomplete from './autocompletes/AuthorsAutocomplete/Component'
import Box from './box/Box'
import BoxMore from './box/BoxMore'
import CardInfo from './cards/CardInfo'
import CardPerson from './cards/CardPerson'
import CollectionsAutocomplete from './autocompletes/CollectionsAutocomplete/Component'
import Datepicker from './form/Datepicker'
import EmptyList from './helpers/EmptyList'
import ErrorBox from './ErrorBox/Component'
import FileUpload from './helpers/FileUpload'
import FormGroup from './form/FormGroup'
import FormSwitch from './form/FormSwitch'
import KeywordsAutocomplete from './autocompletes/KeywordsAutocomplete/Component'
import ListManager from './helpers/ListManager'
import MaskedMoney from './form/MaskedMoney'
import Modal from './helpers/Modal'
import PageTitle from './layout/PageTitle'
import ProductsAutocomplete from './autocompletes/ProductsAutocomplete/Component'
import UserAvatar from './helpers/UserAvatar'
import ZipcodeInput from './form/ZipcodeInput'
import pickers from './pickers'
import PlanAutocomplete from './autocompletes/PlanAutocomplete/Autocomplete'
import FillLoading from './helpers/FillLoading'

export default {
  install(vue) {
    vue.component('authors-autocomplete', AuthorsAutocomplete)
    vue.component('box', Box)
    vue.component('box-more', BoxMore)
    vue.component('card-info', CardInfo)
    vue.component('card-person', CardPerson)
    vue.component('collections-autocomplete', CollectionsAutocomplete)
    vue.component('datepicker', Datepicker)
    vue.component('empty-list', EmptyList)
    vue.component('error-box', ErrorBox)
    vue.component('file-upload', FileUpload)
    vue.component('form-group', FormGroup)
    vue.component('form-switch', FormSwitch)
    vue.component('keywords-autocomplete', KeywordsAutocomplete)
    vue.component('list-manager', ListManager)
    vue.component('masked-money', MaskedMoney)
    vue.component('modal', Modal)
    vue.component('page-title', PageTitle)
    vue.component('products-autocomplete', ProductsAutocomplete)
    vue.component('user-avatar', UserAvatar)
    vue.component('zipcode-input', ZipcodeInput)
    vue.component('plan-autocomplete', PlanAutocomplete)
    vue.component('fill-loading', FillLoading)
    vue.use(pickers)
  },
}
